module.exports = __webpack_public_path__ + "img/電気回路_4_5.4a87c5a3.png";